/**
 * Route for `default-campaign-url-vs-publisher-override`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DefaultCampaignUrlVsPublisherOverridePage } from "../features/default-campaign-url-vs-publisher-override/DefaultCampaignUrlVsPublisherOverridePage";

export const defaultCampaignUrlVsPublisherOverrideRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/default-campaign-url-vs-publisher-override",
	component: DefaultCampaignUrlVsPublisherOverridePage,
});

export default defaultCampaignUrlVsPublisherOverrideRoute;
